// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2YQEE","left":"styles_left__2_WFj"};